import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./EnrichedIcon.less";
import type { IEnrichedIconProps } from "./EnrichedIcon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 116 116"
    {...props}
  >
    <path
      fill="#F1F4FA"
      d="M58 109c28.167 0 51-22.833 51-51 0-28.166-22.833-51-51-51C29.834 7 7 29.834 7 58c0 28.167 22.834 51 51 51"
    />
    <path
      fill="#ACB8C3"
      d="M103.757 36.877a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5"
    />
    <path
      stroke="#C7D0D9"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={3}
      d="M106.994 71 97 80.994M106.994 80.994 97 71"
    />
    <path
      fill="#C7D0D9"
      d="M43.766 104.165a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7"
    />
    <path
      stroke="#C7D0D9"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={3}
      d="M11.066 71v14.133M18.133 78.067H4"
    />
    <path
      stroke="#C7D0D9"
      strokeMiterlimit={10}
      strokeWidth={2}
      d="M94.543 19.84a5 5 0 1 0 0-10 5 5 0 0 0 0 10Z"
    />
    <path
      fill="#C7D0D9"
      d="M82.969 45.107 60.848 27.473a2.91 2.91 0 0 0-3.628 0L35.099 45.107v39.707a4.35 4.35 0 0 0 4.352 4.352h39.166a4.35 4.35 0 0 0 4.352-4.352zM82.969 42.893V27.284c0-.694-.563-1.257-1.257-1.257h-6.189c-.694 0-1.257.563-1.257 1.257v9.95"
    />
    <path
      fill="#F1F4FA"
      d="M52.076 59.363h14.107a2.37 2.37 0 0 1 2.367 2.367v27.435H49.709V61.73a2.37 2.37 0 0 1 2.367-2.367"
    />
    <path
      stroke="#ACB8C3"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={6}
      d="m26.396 50 30.065-22.048a4.35 4.35 0 0 1 5.147 0L91.673 50M30.345 88h57.132"
    />
    <path
      fill="#7B8493"
      fillRule="evenodd"
      d="M48.559 2.664a2.59 2.59 0 0 1-.593 3.616l-12.994 9.337 12.463 2.041a2.591 2.591 0 0 1 1.093 4.662l-21.69 15.585a2.592 2.592 0 1 1-3.024-4.209l16.61-11.934L27.96 19.72a2.592 2.592 0 0 1-1.093-4.662L44.942 2.071a2.59 2.59 0 0 1 3.617.593"
      clipRule="evenodd"
    />
  </svg>
);
const SvgEnrichedIconDamagedHomeGreyscale = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IEnrichedIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("enriched-icon bds-enriched-icon", className, {
        ["bds-enriched-icon-" + size]: size,
        ["enriched-icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgEnrichedIconDamagedHomeGreyscale);
export default Memo;
